import * as React from "react";

/** Re-export for feature code — avoids importing from `app/components/ui`. */
export { useIsMobile } from "@/app/components/ui/use-mobile";

const MD_PX = 768;
const LG_PX = 1024;

function resolveBreakpoint(width: number): "mobile" | "tablet" | "desktop" {
  if (width < MD_PX) return "mobile";
  if (width < LG_PX) return "tablet";
  return "desktop";
}

/**
 * Coarse layout breakpoint aligned with Tailwind defaults:
 * - mobile: &lt;768px (`md:` not yet active)
 * - tablet: 768–1023px
 * - desktop: ≥1024px
 */
export function useBreakpoint(): "mobile" | "tablet" | "desktop" {
  const [bp, setBp] = React.useState<"mobile" | "tablet" | "desktop">(() =>
    typeof window !== "undefined" ? resolveBreakpoint(window.innerWidth) : "desktop",
  );

  React.useEffect(() => {
    const mqlMd = window.matchMedia(`(max-width: ${MD_PX - 1}px)`);
    const mqlLg = window.matchMedia(`(min-width: ${LG_PX}px)`);
    const mqlTabletOnly = window.matchMedia(
      `(min-width: ${MD_PX}px) and (max-width: ${LG_PX - 1}px)`,
    );

    const sync = () => setBp(resolveBreakpoint(window.innerWidth));

    mqlMd.addEventListener("change", sync);
    mqlLg.addEventListener("change", sync);
    mqlTabletOnly.addEventListener("change", sync);
    sync();

    return () => {
      mqlMd.removeEventListener("change", sync);
      mqlLg.removeEventListener("change", sync);
      mqlTabletOnly.removeEventListener("change", sync);
    };
  }, []);

  return bp;
}
